module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-top-bar"
  }, [_c('div', {
    staticClass: "row-1 f-cb"
  }, [(_vm.item.area) ? _c('span', {
    staticClass: "addr f-fl f-toe1"
  }, [_vm._v(_vm._s(_vm.item.area))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "name f-fl f-toe1"
  }, [_vm._v(_vm._s(_vm.item.userName || _vm.item.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "row-2"
  }, [_c('span', {
    staticClass: "praise-btn f-fr"
  }, [_vm._v(_vm._s(_vm.item.likes))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("dateNewComment")(_vm.item.time)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6996ca9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/main-top-bar.vue
// module id = 857
// module chunks = 2